export default __webpack_public_path__ + "fonts/Jost-Regular.woff";